import React, { useState, useEffect } from "react";
import Banner from "../../assets/logos/logo.png";
import NavItems from "./NavItems/NavItems.component";
import { screenRoutes } from "../../routes";
import MenuIcon from "@mui/icons-material/Menu";

import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const SideNav = ({ auth, onToggleOpen }) => {
  const [open, setOpen] = useState(true);
  const isSmallScreen = useMediaQuery("(max-width: 1023px)");

  useEffect(() => {
    if (isSmallScreen) {
      const newOpen = !open;
      setOpen(false);
      onToggleOpen(newOpen);
    }
  }, [isSmallScreen, onToggleOpen]);
  const toggleOpen = () => {
    const newOpen = !open;
    setOpen(newOpen);
    onToggleOpen(newOpen);
  };

  return (
    <div className={open ? "Sidenav" : "Sidenav__closed"}>
      <button className="menuBtn" onClick={toggleOpen}>
        {open ? <MenuIcon /> : <MenuIcon />}
      </button>
      <div>
        <Link to="/dashboard">
          <img src={Banner} alt="banner" className="Sidenav__banner" />
        </Link>
      </div>
      <nav>
        <NavItems auth={auth} routes={screenRoutes} />
      </nav>
    </div>
  );
};
export default SideNav;
